import script from "./messageImg.vue?vue&type=script&setup=true&lang=js"
export * from "./messageImg.vue?vue&type=script&setup=true&lang=js"

import "./messageImg.vue?vue&type=style&index=0&id=7e7dccbb&scoped=true&lang=css"

import exportComponent from "/Users/nasinet/hujing_pro/hj_pro_h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e7dccbb"]])

export default __exports__